(ns app.front.view.pre-consultation.view
  (:require [app.domain.form.model :as form-model]
            [app.front.entities :as entities]
            [app.front.form.add :as add-form]
            [app.front.form.subs :as form-subs]
            [app.front.process :as process]
            [app.front.requirement.subs :as requirement-subs]
            [app.front.ui.section :as section]
            [app.front.util :as futil]
            [app.front.view.application.page-content :as app-page]
            [app.front.view.application.withdrawal :as application-withdrawal]
            [app.front.view.approval.core :as approval]
            [app.front.view.attachment.list :as attachment-list]
            [app.front.view.attachment.subs :as attachment-subs]
            [app.front.view.bond.workspace-section :as bond]
            [app.front.view.case-note.section :as case-note]
            [app.front.view.case-note.subs :as cn-subs]
            [app.front.view.conditions.list :as conditions-list]
            [app.front.view.fee.list :as fee-list]
            [app.front.view.form.list :as form-list]
            [app.front.view.inspections.orders-section :as orders-section]
            [app.front.view.inspections.section :as inspections-section]
            [app.front.view.letter.section :as letter-section]
            [app.front.view.meeting.meeting-section :as meeting-section]
            [app.front.view.package.package-section :as package-section]
            [app.front.view.party.party-section-v2 :as party-section-v2]
            [app.front.view.phase-result :as phase-result]
            [app.front.view.pre-consultation.create-linked-workspaces :as pre-con-create-linked-wss]
            [app.front.view.pre-consultation.linked-workspaces :as pre-con-linked-workspaces]
            [app.front.view.workspace.phase-errors :as phase-errors]
            [app.front.view.workspace.section :as ws-section]
            [app.front.view.workspace.subs :as ws-subs]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.icons :as i]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(def ^:private open-attachments-section-fx
  [[:dispatch [::section/toggle-collapsed (section/get-section-id :pre-consultation-attachments) false]]
   [::futil/scroll-to-section :pre-consultation-attachments]])

(rf/reg-event-fx ::scroll-to-attachments
  (fn [{:keys [db]} _]
    {:db (assoc db ::attachments-section-open? true)
     :fx open-attachments-section-fx}))

(rf/reg-sub ::attachments-section-open?
  (fn [db _]
    (get db ::attachments-section-open? false)))

(rf/reg-event-fx ::trigger-add-attachment-requirement
  (fn [{:keys [db]} _]
    {:db (assoc db ::attachments-section-open? true)
     :fx (conj open-attachments-section-fx
               [:dispatch [:app.front.requirement.components/open-add-requirement-popup]])}))

(rf/reg-event-db ::reset-ui-state
  (fn [db _]
    (dissoc db ::attachments-section-open?)))

(rf/reg-sub ::has-approvals?
  (fn [[_ process-target-id]]
    (rf/subscribe [::entities/entities {:entity/type   :entity.type/approval
                                        :entity/parent process-target-id}]))
  (fn [approvals _]
    (-> approvals seq boolean)))


(defn approval-section [{:keys [tr process-target loading? workspace default-approver-groups]}]
  (let [allow-create? (<sub [::process/signal-permitted?
                             process-target
                             [:process.signal/create-approval]])
        has-existing? (<sub [::has-approvals? (:db/id process-target)])]
    (when (or has-existing? allow-create?)
      [ws-section/section
       process-target
       :pre-consultation-approvals
       (let [state (util/mmap tr loading?)]
         (if allow-create?
           (assoc state :heading-button (cc/button {:icon             i/plus
                                                    :icon-description (tr [:approval/add-request])
                                                    :kind             :ghost
                                                    :on-click         #(>evt (if (ff/enabled? :feature-flag.id/multi-circulation-requests)
                                                                               [::approval/initialize-add-request-v2 default-approver-groups]
                                                                               [::approval/add-request]))}
                                                   (tr [:approval/add-request])))
           state))
       :approval/approvals
       true
       [approval/approval-components (util/mmap tr process-target workspace default-approver-groups)]])))


(defn form-section [{:keys [loading? workspace tr]} pre-consultation]
  [:<>
   (when (or (seq (form-model/forms pre-consultation))
             (<sub [::process/signal-permitted? (:db/id pre-consultation) [:process.signal/add-form]]))
     [ws-section/section
      pre-consultation
      :pre-consultation-forms
      (util/mmap {:heading-button    [add-form/add-button {:process-target-id  (:db/id pre-consultation)
                                                           :authority-group-id (-> workspace
                                                                                   :domain/authority-group
                                                                                   :db/id)
                                                           :opts               {:kind :ghost
                                                                                :icon i/plus}
                                                           :button-text        (tr [:process.signal/add-form])
                                                           :add-text           (tr [:add])
                                                           :cancel-text        (tr [:cancel])}]
                  :heading-tag       (<sub [::form-subs/phase-forms-count pre-consultation])
                  :heading-tag-color (if (<sub [::form-subs/missing-any-data? pre-consultation]) :yellow :green)}
                 tr loading?)
      :pre-consultation/data
      false
      [form-list/forms
       (util/mmap {:parent pre-consultation
                   :lang   (<sub [:language])}
                  tr
                  workspace
                  loading?)]])
   [add-form/add-form-modal {:tr tr :process-target pre-consultation}]])


(defn attachment-section [{:keys [tr loading?]} match pre-consultation]
  (let [attachments?         (<sub [::attachment-subs/has-attachments? (:db/id pre-consultation)])
        requirements?        (seq (<sub [::requirement-subs/open-attachment-requirements (:db/id pre-consultation)]))
        section-open?        (<sub [::attachments-section-open?])
        ui-improvements?     (<sub [::ff/enabled? :feature-flag.id/inspection-ui-improvements])
        show-section?        (if ui-improvements?
                               (or attachments? requirements? section-open?)
                               true)
        pre-selected-id      (-> match :parameters :query :id)
        initially-collapsed? (not (or section-open? pre-selected-id))]
    (when show-section?
      [ws-section/section
       pre-consultation
       :pre-consultation-attachments
       (util/mmap {:error? requirements?} tr loading?)
       :view/application-attachments
       initially-collapsed?
       [attachment-list/list-view
        {:target          pre-consultation
         :pre-selected-id pre-selected-id}]])))


(defn phase-pre-consultation [{:keys [loading? workspace tr]} match]
  (let [pre-consultation        (<sub [::ws-subs/pre-consultation])
        section-state           (util/mmap {:parent     pre-consultation
                                            :fsm-target pre-consultation}
                                           tr)
        default-approver-groups (<sub [::ws-subs/default-approver-groups])]
    [app-page/page-content
     (util/mmap {:process-target pre-consultation
                 :process        (<sub [::process/pre-consultation-process])}
                tr
                loading?
                workspace)
     [phase-errors/errors tr [::process/pre-consultation-process]]
     [application-withdrawal/withdrawal-info section-state]
     [application-withdrawal/cancel-withdrawal-info section-state]
     [application-withdrawal/rejection-info section-state]
     [phase-result/result-section section-state]
     [pre-con-linked-workspaces/section]
     [bond/workspace-bonds-section section-state]
     [conditions-list/conditions-and-comments-section
      (assoc section-state :workspace workspace)
      pre-consultation
      {:section-title-key      :condition/conditions
       :title-key              :condition/conditions
       :help?                  false
       :comments?              false
       :conditions-subsection? false
       :show-when-can-create?  false
       :show-when-creating?    true}]
     [party-section-v2/parties section-state]
     [form-section (util/mmap tr loading? workspace) pre-consultation]
     [attachment-section (util/mmap tr loading?) match pre-consultation]
     (when (<sub [::cn-subs/show-case-notes-section? (:db/id pre-consultation)])
       [case-note/section {:phase pre-consultation :state section-state}])
     (when (<sub [::ws-subs/has-feature? :fees-and-payments?])
       [fee-list/fees-and-payments-section (util/mmap tr loading?) pre-consultation])
     [approval-section (util/mmap {:process-target pre-consultation}
                                  tr loading? workspace default-approver-groups)]
     [meeting-section/meetings section-state]
     [inspections-section/inspections-section (assoc section-state
                                                     :target-entity pre-consultation
                                                     :section-id :pre-consultation-inspections
                                                     :workspace workspace)]
     (when (and (<sub [::ws-subs/has-feature? :orders-for-inspections-enabled?])
                (<sub [::ff/enabled? :feature-flag.id/pre-issuance-inspections]))
       [orders-section/section (assoc section-state
                                      :target-entity pre-consultation
                                      :workspace workspace)])
     (when (<sub [::process/pre-consultation-signal-permitted? [:process.signal/create-admin-package]])
       [package-section/packages (util/mmap {:target-entity pre-consultation} workspace tr)])
     [letter-section/letters-section (util/mmap {:target-id (:db/id pre-consultation)} tr)]
     [pre-con-create-linked-wss/modal tr]]))
